import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { getAccountPurchasesCompleteStatusCounts } from 'Services/api/account';
import { logger } from 'Services/logger/logger';
import type { DateRangeFilterValue } from 'Types/account';
import type { PurchasesCompleteStatusTypes } from 'Types/purchaseCompleteStatus';

export type AccountStatusCounts = Record<PurchasesCompleteStatusTypes, number>;

export type AccountStatusCountsParams = {
	hideDeliveredEnquiries?: boolean;
	keyword?: string;
} & DateRangeFilterValue;

type UseAccountStatusCountsPayload = {
	isFeatureFlagOn: boolean;
	keepPreviousData?: boolean;
	params: AccountStatusCountsParams;
};

export const useAccountBiddingStatusCounts = ({
	isFeatureFlagOn,
	keepPreviousData,
	params,
}: UseAccountStatusCountsPayload): UseQueryResult<AccountStatusCounts> =>
	useQuery({
		enabled: isFeatureFlagOn,
		keepPreviousData,
		onError: (e) => {
			const message = `There was an issue with fetching bidding status counts in account page`;
			const error = e instanceof Error ? e : new Error(message);

			logger.error({ context: { extra: { info: message } }, error, message, scope: 'useAccountBiddingStatusCounts' });
		},
		queryFn: () => getAccountPurchasesCompleteStatusCounts(params),
		queryKey: ['accountBiddingStatusCounts', params],
	});
